module.exports = __webpack_public_path__ + "static/media/5DPO14.135c884b.jpg";